import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../../environments/environment';
import { ClaudeConnection, ClaudeConnectService } from '../../claude-connect/claude-connect.service';

/** How to connect Claude to Resumo, and the Claude clients connected as this user. */
@Component({
    selector: 'app-claude-settings',
    templateUrl: './claude-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ClaudeSettingsComponent implements OnInit {
    readonly connections = signal<ClaudeConnection[]>([]);
    readonly loading = signal(true);
    readonly mcpUrl = `${environment.baseUrl}/mcp`;

    constructor(private service: ClaudeConnectService, private toastr: ToastrService) {}

    ngOnInit(): void {
        this.load();
    }

    revoke(connection: ClaudeConnection): void {
        this.service.revoke(connection.grantId).subscribe({
            next: () => {
                this.toastr.success(`${connection.clientName} heeft geen toegang meer.`);
                this.load();
            },
            error: () => this.toastr.error('Intrekken mislukt. Probeer het opnieuw.'),
        });
    }

    copyUrl(): void {
        navigator.clipboard?.writeText(this.mcpUrl).then(() => this.toastr.success('URL gekopieerd'));
    }

    private load(): void {
        this.loading.set(true);
        this.service.getConnections().subscribe({
            next: (connections) => {
                this.connections.set(connections || []);
                this.loading.set(false);
            },
            error: () => {
                this.connections.set([]);
                this.loading.set(false);
            },
        });
    }
}
